import React from "react";
import { Col, Row, Carousel } from "react-bootstrap";


const groupByWidth = (pages, chunkSize) => {
  const getWidth = (p) => (p.type === 1 ? 2 : 1);

  const slides = [];
  let current = [];
  let width = 0;

  pages.forEach((page) => {
    const w = getWidth(page);

    if (width + w > chunkSize) {
      slides.push(current);
      current = [];
      width = 0;
    }

    current.push(page);
    width += w;
  });

  if (current.length) slides.push(current);

  if (slides.length < 2) return slides;

  let lastSlide = slides[slides.length - 1];
  const getSlideWidth = (slide) => slide.reduce((sum, p) => sum + getWidth(p), 0);

  while (getSlideWidth(lastSlide) < chunkSize) {
    let added = false;

    for (let i = slides.length - 2; i >= 0; i--) {
      const prevSlide = slides[i];
      for (let j = prevSlide.length - 1; j >= 0; j--) {
        const p = prevSlide[j];
        const w = getWidth(p);
        if (getSlideWidth(lastSlide) + w <= chunkSize) {
          lastSlide.unshift(p);
          added = true;
        }
        if (getSlideWidth(lastSlide) >= chunkSize) break;
      }
      if (getSlideWidth(lastSlide) >= chunkSize) break;
    }

    if (!added) break;
  }

  return slides;
};

const renderCarouselItems = (pages, chunkSize, handleRedirectClick, type) => {
  const slides = groupByWidth(pages, chunkSize);

  return slides.map((slide, index) => (
    <Carousel.Item key={index}>
      <Row className="gx-3">
        {slide.map((page) => (
          <Col
            key={page.id}
            lg={page.type === 1 ? 6 : 3}
            xs={page.type === 1 ? 12 : 6}
            onClick={() => {
              if (type) localStorage.setItem("generatorType", type);
              handleRedirectClick(page.id);
            }}
          >
            <div className="d-flex justify-content-center cursor-pointer template-card">
              <img
                className="cursor-pointer"
                src={page.image}
                alt={`Template Card ${page.id}`}
                loading="lazy"
              />
            </div>
          </Col>
        ))}
      </Row>
    </Carousel.Item>
  ));
};

export default renderCarouselItems